<a class="username" [routerLink]="profileUrl">&#64;{{user.username}}</a>

@if (tag === 'official') {
  <span matTooltip="This is a verified official account" class="official tag">Official</span>
}
